import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { HomePageWidgetBlueprint } from '@backstage/plugin-home-react/alpha';
import { MarkdownContent } from '@backstage/core-components';

const content = `
## Spatialwalk Delivery Portal

Use this portal to inspect service state and prepare auditable delivery changes.
GitHub remains the approval record and regional Argo CD instances execute only
merged changes.

### Quick Start

- **Release a service** — Open the [Releases](/releases) page
- **Explore ownership** — Browse the [Software Catalog](/catalog)
- **Review infrastructure** — Inspect [spatialwalk/iac](https://github.com/spatialwalk/iac)

### Helpful Links

- [GKE workloads](https://console.cloud.google.com/kubernetes/workload_/gcloud/us-west1/spatialwalk-prod-gcp-us-west-01?project=adept-cosine-475813-t1)
- [Argo CD documentation](https://argo-cd.readthedocs.io/)
`;

const gettingStartedWidget = HomePageWidgetBlueprint.make({
  name: 'getting-started',
  params: {
    name: 'GettingStarted',
    title: 'Delivery entry points',
    description: 'Release and infrastructure entry points',
    components: async () => ({
      Content: () => <MarkdownContent content={content} />,
    }),
  },
});

export const homeModule = createFrontendModule({
  pluginId: 'home',
  extensions: [gettingStartedWidget],
});
